// @flow
import {
  INK_TOOLING_MEDIA_URL,
  APP_PUSH_ANALYTICS_DASHBOARD_URL,
  SWIPEABLE_ANALYTICS_URL,
  NEWSLETTER_ANALYTICS_URL,
  LIVEBLOG_ANALYTICS_URL,
} from './constants';
import mainTheme from '../../../theme/main';

export type Tool = {
  id: string;
  title: string;
  bgColor: string;
  icon: string;
  actionButton?: string;
  links?: string[];
  hasLiveBadge?: boolean;
};

const { colors } = mainTheme;

const ActionButton = ({ text, icon }: { text: string, icon: string }) => {
  return (
    <div className="d-flex flex-row align-items-center">
      <span>{text}</span>
      <img className="ml-2" width="12" src={icon} alt="Chevron Right" />
    </div>
  );
};

export const tools: Tool[] = [
  {
    id: 'app-push',
    title: 'App Push Alerts',
    bgColor: colors.cardAccentLavender,
    icon: <img width="24" src={`${INK_TOOLING_MEDIA_URL}/apps-2-add-fill-1.svg`} alt="App Push Alerts" />,
      actionButton: <ActionButton text="Compose" icon={`${INK_TOOLING_MEDIA_URL}/open-caret.svg`} />,
    links: [
      {
        text: 'Analytics Dashboard',
        target: '_blank',
        route: APP_PUSH_ANALYTICS_DASHBOARD_URL
      }
    ],
    route: '/notifications'
  },
  {
    id: 'email-alerts',
    title: 'Email Alert Templates',
    bgColor: colors.cardAccentMint,
    icon: <img width="24" src={`${INK_TOOLING_MEDIA_URL}/alarm-warning-fill-1.svg`} alt="Email Alert Templates" />,
    actionButton: <ActionButton text="Compose" icon={`${INK_TOOLING_MEDIA_URL}/open-caret.svg`} />,
    links: [
      {
        text: 'Analytics Dashboard',
        target: '_blank',
        route: NEWSLETTER_ANALYTICS_URL,
      }
    ],
    route: '/inkbox-v2/alert'
  },
  {
    id: 'liveblog',
    title: 'Liveblog',
    bgColor: colors.cardAccentPink,
    icon: <img width="24" src={`${INK_TOOLING_MEDIA_URL}/live.svg`} alt="Liveblog" />,
    actionButton: <ActionButton text="Edit" icon={`${INK_TOOLING_MEDIA_URL}/open-caret.svg`} />,
    hasLiveBadge: true,
    links: [
      {
        text: 'Analytics Dashboard',
        target: '_blank',
        route: LIVEBLOG_ANALYTICS_URL,
      }
    ],
    route: '/ink-blog'
  },
  {
    id: 'pagebuilder',
    title: 'Pagebuilder Scheduler',
    bgColor: colors.cardAccentRose,
    icon: <img width="24" src={`${INK_TOOLING_MEDIA_URL}/calendar-schedule-fill-1.svg`} alt="Pagebuilder Scheduler" />,
    actionButton: <ActionButton text="Create" icon={`${INK_TOOLING_MEDIA_URL}/open-caret.svg`} />,
    links: [
      {
        text: 'Pages',
        route: '/pb-scheduler?tab=pages'
      },
      {
        text: 'Schedule',
        route: '/pb-scheduler?tab=schedule'
      }
    ],
    route: '/pb-scheduler?tab=pages'
  },
  {
    id: 'newsletters',
    title: 'Newsletters',
    bgColor: colors.cardAccentBlue,
    icon: <img width="24" src={`${INK_TOOLING_MEDIA_URL}/mail-volume-fill-1.svg`} alt="Newsletters" />,
    links: [
      {
        text: 'Original Templates',
        route: '/inkbox-v2/original'
      },
      {
        text: 'Curated Templates',
        route: '/inkbox-v2/curated'
      },
      {
        text: 'Marketing',
        route: '/inkbox-v2/marketing'
      },
      {
        text: 'Ads',
        route: '/inkbox-v2/ads'
      },
      {
        text: 'Paywall Setup',
        route: '/inkbox-v2/paywall-setup'
      },
      {
        text: 'Analytics Dashboard',
        target: '_blank',
        route: NEWSLETTER_ANALYTICS_URL,
      }
    ],
  },
  {
    id: 'swipeable',
    title: 'Swipeable Stories',
    bgColor: colors.cardAccentYellow,
    icon: <img width="24" src={`${INK_TOOLING_MEDIA_URL}/swipeable-stories-filled-icon-3.svg`} alt="Swipeable Stories" />,
    actionButton: <ActionButton text="Edit" icon={`${INK_TOOLING_MEDIA_URL}/open-caret.svg`} />,
    links: [
      {
        text: 'Analytics Dashboard',
        target: '_blank',
        route: SWIPEABLE_ANALYTICS_URL,
      }
    ],
    route: '/swipeable'
  },
  {
    id: 'app-features',
    title: 'App Features',
    bgColor: colors.cardAccentPeach,
    icon: <img width="24" src={`${INK_TOOLING_MEDIA_URL}/apps-2-fill-1.svg`} alt="App Features" />,
    links: [
      {
        text: 'Active Sections',
        route: '/sections'
      },
      {
        text: 'Top Story Curation',
        route: '/curations'
      },
      {
        text: 'Featured Stories',
        route: '/featured-stories'
      }
    ],
  },
  {
    id: 'weekend-note',
    title: 'Weekend Note',
    bgColor: colors.cardAccentPlum,
    icon: <img width="24" src={`${INK_TOOLING_MEDIA_URL}/edit-circle-fill-1.svg`} alt="Weekend Note" />,
    actionButton: <ActionButton text="Create" icon={`${INK_TOOLING_MEDIA_URL}/open-caret.svg`} />,
    route: '/weekend-note'
  },
  {
    id: 'apple-news',
    title: 'Apple News',
    bgColor: colors.cardAccentGray,
    icon: <img width="24" src={`${INK_TOOLING_MEDIA_URL}/apple-logo.webp`} alt="Apple News" />,
    actionButton: <ActionButton text="Publish" icon={`${INK_TOOLING_MEDIA_URL}/open-caret.svg`} />,
    route: '/apple-news'
  }
];
